import { PillTheme } from "@redotech/redo-model/pill-theme";
import classnames from "classnames";
import { ReactNode, memo } from "react";
import * as pillCss from "./pill.module.css";
import * as wrapCss from "./wrap.module.css";

export enum PillSize {
  MEDIUM = 0,
  SMALL = 1,
  XSMALL = 2,
  NEAR_SQUARE = 3,
}

const pillThemeClass: Record<PillTheme, string> = {
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY]: pillCss.primary,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NORMAL]: pillCss.normal,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.PRIMARY_LIGHT]: pillCss.primaryLight,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SUCCESS]: pillCss.success,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.DANGER]: pillCss.danger,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_YELLOW]: pillCss.neutralYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.NEUTRAL_BLUE]: pillCss.neutralBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.LIGHT_PINK]: pillCss.lightPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_WHITE]: pillCss.solidWhite,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_RED]: pillCss.solidRed,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_YELLOW]: pillCss.solidYellow,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_GREEN]: pillCss.solidGreen,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_NAVY]: pillCss.solidNavy,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_LIGHT_BLUE]: pillCss.solidLightBlue,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_PINK]: pillCss.solidPink,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_ORANGE]: pillCss.solidOrange,
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  [PillTheme.SOLID_BLACK]: pillCss.solidBlack,
};

const pillSizeClass = new Map<PillSize, string>();
// @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
pillSizeClass.set(PillSize.MEDIUM, pillCss.medium);
// @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
pillSizeClass.set(PillSize.SMALL, pillCss.small);
// @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
pillSizeClass.set(PillSize.XSMALL, pillCss.xsmall);
// @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
pillSizeClass.set(PillSize.NEAR_SQUARE, pillCss.nearSquare);

export const Pill = memo(function Pill({
  children,
  truncate = false,
  size,
  theme = PillTheme.NORMAL,
  preventCapitalize = false,
  shadow = false,
}: {
  children: ReactNode | ReactNode[];
  size?: PillSize;
  theme?: PillTheme;
  truncate?: boolean;
  preventCapitalize?: boolean;
  shadow?: boolean;
}) {
  return (
    <div
      className={classnames(
        pillCss.pill,
        size !== undefined && pillSizeClass.get(size),
        pillThemeClass[theme],
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        { [wrapCss.truncate]: truncate },
        // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
        { [pillCss.shadow]: shadow },
        preventCapitalize && pillCss.noCapitalize,
      )}
    >
      {children}
    </div>
  );
});

export { PillTheme } from "@redotech/redo-model/pill-theme";
